import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './Fade.scss';

const Fade = ({ show, children }) => {
  const [shouldRender, setShouldRender] = useState(show);

  useEffect(() => {
    if (show) setShouldRender(true);
  }, [show]);

  const handleAnimationEnd = () => {
    if (!show) setShouldRender(false);
  };

  return (
    shouldRender && (
      <div
        className="fade-item"
        style={{ animation: `${show ? 'fadeIn' : 'fadeOut'} 0.5s` }}
        onAnimationEnd={handleAnimationEnd}
      >
        {children}
      </div>
    )
  );
};

Fade.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};

export default Fade;
